import { ZERO } from "./appConstants";

export const getPricingPlanFormConfig = ({
  createPricingPlan,
  createAccPage,
  userStatus,
  selectedTriggers,
  planGroup,
  isRiskBased,
  isEdit
}) => [
  {
    type: "input",
    name: "pricingPlanName",
    label: createPricingPlan?.pricingName,
    placeholder: createPricingPlan?.pricingName,
    required: true
  },
  {
    type: "group",
    label: createPricingPlan?.standardPricing,
    fields: [
      {
        type: "input",
        name: "flatRate",
        label: createPricingPlan?.flatRate,
        placeholder: createPricingPlan?.placeHolder?.item1,
        min: ZERO,
        inputType: "number",
        disabled: isEdit && !isRiskBased
      },
      {
        type: "input",
        name: "annualRate",
        label: createPricingPlan?.parate,
        placeholder: createPricingPlan?.placeHolder?.item2,
        min: ZERO,
        inputType: "number",
        disabled: isEdit && !isRiskBased
      }
    ]
  },
  {
    type: "group",
    label: createPricingPlan?.overdue,
    fields: [
      {
        type: "input",
        name: "extraFlatRate",
        label: createPricingPlan?.flatRateAddnl,
        placeholder: createPricingPlan?.placeHolder?.item1,
        min: ZERO,
        inputType: "number",
        disabled: isEdit && !isRiskBased
      },
      {
        type: "input",
        name: "extraAnnualRate",
        label: createPricingPlan?.parateAddnl,
        placeholder: createPricingPlan?.placeHolder?.item2,
        min: ZERO,
        inputType: "number",
        disabled: isEdit && !isRiskBased
      }
    ]
  },
  {
    type: "radio",
    name: "isAutoSwitching",
    label: createPricingPlan?.autoSwithing,
    options: [
      { label: createAccPage.active, value: createAccPage.active },
      { label: createAccPage.inactive, value: createAccPage.inactive }
    ]
  },
  {
    type: "multiSelect",
    name: "triggerEvents",
    label: createPricingPlan?.triggerForoverdue,
    options: userStatus,
    value: selectedTriggers,
    required: true
  },
  ...(!isRiskBased
    ? [
        {
          type: "industry",
          name: "industryCategoryId",
          label: createPricingPlan?.forIndustryType
        },
        {
          type: "select",
          name: "invoiceSyncType",
          label: "Accounting Software",
          options: "accountingSoftware"
        },
        {
          type: "select",
          name: "eligibleOrganizationType",
          label: createPricingPlan?.orgtype,
          options: "orgType"
        },
        {
          type: "select",
          name: "applicableCountry",
          label: createPricingPlan?.country,
          options: "country"
        },
        {
          type: "select",
          name: "ownershipStatus",
          label: createPricingPlan?.propertyOwnership,
          options: "ownership"
        }
      ]
    : []),
  {
    type: "select",
    name: "isRiskBased",
    label: createPricingPlan?.riskbased,
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false }
    ]
  },
  ...(isRiskBased
    ? [
        {
          type: "select",
          name: "primaryPricingPlanId",
          label: createPricingPlan?.selectGrp,
          options: [
            { label: "-Select Group Name-", value: "" },
            ...(planGroup?.map((p) => ({
              label: p.pricingPlanName,
              value: p.id
            })) || [])
          ]
        },
        {
          type: "input",
          name: "minApplicableValue",
          label: createPricingPlan?.minlimit,
          placeholder: createPricingPlan?.placeHolder?.item2,
          step: "any",
          min: ZERO,
          inputType: "number",
          required: true
        },
        {
          type: "input",
          name: "maxApplicableValue",
          label: createPricingPlan?.maxlimit,
          placeholder: createPricingPlan?.placeHolder?.item2,
          step: "any",
          min: ZERO,
          inputType: "number",
          required: true
        }
      ]
    : [])
];
